// extracted by mini-css-extract-plugin
module.exports = {"left":"_account_left__2fq0A","formPage":"_account_formPage__1c1_O","accountRequestDescription":"_account_accountRequestDescription__2Aabv"};